const state = {
  message: null,
  loading: null
}

const getters = {
  message: (state) => state.message,
  loading: (state) => state.loading
}

const mutations = {
  setLoading: (state, msg) => state.loading = msg,
  unsetLoading: (state) => state.loading = null,
  setMessage: (state, msg) => state.message = msg,
  unsetMessage: (state) => state.message = null
}

export default {
  state,
  getters,
  mutations
}
